module.exports = __webpack_public_path__ + "img/jhc.f4e45ad2.png";